import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { "clip-path": "url(#photo-frame-clip)" }
const _hoisted_3 = ["xlink:href"]
const _hoisted_4 = {
  key: 1,
  class: "simple-photo"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 4,
  class: "progress-indicators"
}
const _hoisted_7 = ["onClick"]

import { ref, onMounted, onUnmounted, watch } from 'vue';
import MultiPageImage from '@/components/primevue/MultiPageImage.vue';

interface Props {
  photos: string[];
  interval?: number;
  showFrame?: boolean;
  showIndicators?: boolean;
  altTexts?: string[];
  enablePreview?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PhotoSlider',
  props: {
    photos: {},
    interval: { default: 3000 },
    showFrame: { type: Boolean, default: true },
    showIndicators: { type: Boolean, default: true },
    altTexts: { default: () => [] },
    enablePreview: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const currentPhotoIndex = ref(0);
let photoInterval: number | null = null;
const isPreviewOpen = ref(false);
const multiPageImageRef = ref<any>(null);

const currentPhoto = () => props.photos[currentPhotoIndex.value]
const currentAlt = () => (props.altTexts && props.altTexts[currentPhotoIndex.value]) ? props.altTexts[currentPhotoIndex.value] : `Photo ${currentPhotoIndex.value + 1}`

function openPreview() {
  if (multiPageImageRef.value) {
    // Устанавливаем текущую страницу в MultiPageImage
    if (multiPageImageRef.value.currentPage !== undefined) {
      multiPageImageRef.value.currentPage = currentPhotoIndex.value;
    }
    
    // Находим кнопку preview
    const previewButton = multiPageImageRef.value.$el?.querySelector('.p-image-preview-indicator') ||
                         multiPageImageRef.value.$el?.querySelector('button');
    
    if (previewButton) {
      previewButton.click();
    }
  }
}

// Обработчик смены страницы в preview
function onPreviewPageChange(newPageIndex: number) {
  // Синхронизируем основной слайдер с preview
  currentPhotoIndex.value = newPageIndex;
  
  // Перезапускаем интервал, когда preview закрыт
  if (!isPreviewOpen.value) {
    startInterval();
  }
}

const changePhoto = () => {
  currentPhotoIndex.value = (currentPhotoIndex.value + 1) % props.photos.length;
};

const startInterval = () => {
  if (isPreviewOpen.value) return; // do not auto-rotate while preview is open
  if (photoInterval) clearInterval(photoInterval);
  photoInterval = setInterval(changePhoto, props.interval);
};

const goToPhoto = (index: number) => {
  currentPhotoIndex.value = index;
  startInterval();
};

const handlePrev = () => {
  currentPhotoIndex.value = (currentPhotoIndex.value - 1 + props.photos.length) % props.photos.length;
  if (!isPreviewOpen.value) startInterval();
};

const handleNext = () => {
  currentPhotoIndex.value = (currentPhotoIndex.value + 1) % props.photos.length;
  if (!isPreviewOpen.value) startInterval();
};


onMounted(() => {
  startInterval();
});

watch(isPreviewOpen, (open) => {
  if (open) {
    if (photoInterval) {
      clearInterval(photoInterval);
      photoInterval = null;
    }
  } else {
    startInterval();
  }
});

onUnmounted(() => {
  if (photoInterval) clearInterval(photoInterval);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "photo-slider",
    style: _normalizeStyle({'--slider-aspect-ratio': _ctx.showFrame ? '468/604' : '3/4'})
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["slider-container", { 'with-frame': _ctx.showFrame }])
    }, [
      (_ctx.showFrame)
        ? (_openBlock(), _createElementBlock("svg", {
            key: 0,
            viewBox: "0 0 468 604",
            preserveAspectRatio: "xMidYMid meet",
            role: "img",
            "aria-label": _ctx.altTexts && _ctx.altTexts.length ? _ctx.altTexts[currentPhotoIndex.value] : undefined
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("defs", null, [
              _createElementVNode("clipPath", { id: "photo-frame-clip" }, [
                _createElementVNode("path", { d: "M48.1616 34.1354C50.2902 30.2234 53.953 27.3756 58.2689 26.277L159.558 0.494444C160.847 0.166097 162.173 0 163.504 0H451.193C460.03 0 467.193 7.16344 467.193 16V480.5V587.293C467.193 596.129 460.03 603.293 451.193 603.293H331H16.0804C7.24388 603.293 0.0804443 596.129 0.0804443 587.293V126.571C0.0804443 123.9 0.74939 121.271 2.02625 118.924L48.1616 34.1354Z" })
              ])
            ], -1)),
            _createElementVNode("g", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photo, index) => {
                return (_openBlock(), _createElementBlock("image", {
                  key: index,
                  "xlink:href": photo,
                  width: "100%",
                  height: "100%",
                  preserveAspectRatio: "xMidYMid slice",
                  class: _normalizeClass({ active: currentPhotoIndex.value === index })
                }, null, 10, _hoisted_3))
              }), 128)),
              _createElementVNode("rect", {
                x: "0",
                y: "0",
                width: "100%",
                height: "100%",
                fill: "transparent",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.enablePreview && openPreview()), ["stop"]))
              })
            ])
          ], 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photo, index) => {
              return (_openBlock(), _createElementBlock("img", {
                key: index,
                src: photo,
                alt: _ctx.altTexts && _ctx.altTexts[index] ? _ctx.altTexts[index] : `Photo ${index+1}`,
                class: _normalizeClass({ active: currentPhotoIndex.value === index })
              }, null, 10, _hoisted_5))
            }), 128))
          ])),
      (_ctx.photos.length > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "nav-arrow prev",
            onClick: _withModifiers(handlePrev, ["stop"])
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              width: "24",
              height: "24"
            }, [
              _createElementVNode("path", { d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" })
            ], -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.photos.length > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            class: "nav-arrow next",
            onClick: _withModifiers(handleNext, ["stop"])
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              width: "24",
              height: "24"
            }, [
              _createElementVNode("path", { d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" })
            ], -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.showIndicators && _ctx.photos.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (_, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "progress-track",
                onClick: _withModifiers(($event: any) => (goToPhoto(index)), ["stop"])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["progress-bar", { active: currentPhotoIndex.value === index }]),
                  style: _normalizeStyle({ 'animation-duration': `${_ctx.interval}ms` })
                }, null, 6)
              ], 8, _hoisted_7))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.enablePreview)
      ? (_openBlock(), _createBlock(MultiPageImage, {
          key: 0,
          pages: props.photos,
          src: currentPhoto(),
          alt: currentAlt(),
          preview: "",
          onShow: _cache[1] || (_cache[1] = ($event: any) => (isPreviewOpen.value = true)),
          onHide: _cache[2] || (_cache[2] = ($event: any) => (isPreviewOpen.value = false)),
          onPageChange: onPreviewPageChange,
          ref_key: "multiPageImageRef",
          ref: multiPageImageRef,
          class: "preview-image"
        }, null, 8, ["pages", "src", "alt"]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})